import { Fragment } from 'react';

import { SkeletonEditorLoader } from '@/ui/skeleton/SkeletonEditorLoader';
import { SkeletonList } from '@/ui/skeleton/SkeletonList';
import { SkeletonLoader } from '@/ui/skeleton/SkeletonLoader';

export const ObjectRemedyPageSkeleton = () => {
  return (
    <div className="flex size-full">
      <div className="flex h-full w-60 shrink-0 flex-col border-r border-white/10">
        <div className="flex shrink-0 items-center gap-2 overflow-hidden truncate border-b border-white/10 p-4">
          <SkeletonLoader className="h-5 w-full rounded-sm" />
        </div>
        <div className="flex min-h-0 flex-1 flex-col">
          <span className="shrink-0 p-2 text-xs text-white/50">Objects and sub objects</span>
          <div className="min-h-0 flex-1 overflow-y-auto p-2">
            <SkeletonList count={10} classes={{ item: 'h-9 rounded-sm' }} />
          </div>
        </div>
      </div>
      <div className="flex min-w-0 flex-1 items-center justify-center">
        <SkeletonEditorLoader lineCount={30} className="size-full gap-2 p-4 pt-8" />
      </div>
      <div className="flex h-full w-80 shrink-0 flex-col border-l border-white/10">
        <div className="flex h-fit w-full flex-col items-center justify-between gap-2 border-b border-white/10 p-4">
          <SkeletonLoader className="h-5 w-full rounded-sm" />
        </div>
        <div className="flex flex-col gap-3 px-2 py-4">
          <SkeletonLoader className="h-14 rounded-sm" />
          <SkeletonLoader className="h-14 rounded-sm" />
          {Array.from({ length: 3 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Fragment key={index}>
              <SkeletonLoader className="h-14 rounded-sm" />
              <div className="flex flex-col gap-1">
                <SkeletonLoader className="h-40 w-full rounded-sm" />
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

ObjectRemedyPageSkeleton.displayName = 'ObjectRemedyPageSkeleton';
